(function () {
  function restorePenetrationDots() {
    var dots = document.querySelectorAll('.comparison-page .penetration-viz .peptide-dot');

    dots.forEach(function (dot) {
      dot.classList.add('no-empty');
      dot.style.display = 'block';
    });

    var degradationBars = document.querySelectorAll('.comparison-page .degradation-vis .deg-bar');

    degradationBars.forEach(function (bar) {
      bar.classList.add('no-empty');
      bar.style.display = 'block';
      bar.style.height = '100%';
    });

    var scorecardFills = document.querySelectorAll('.comparison-page .scorecard .sc-bar-fill');

    scorecardFills.forEach(function (fill) {
      fill.classList.add('no-empty');
      fill.style.display = 'block';
    });

    if (!dots.length && !degradationBars.length && !scorecardFills.length) return;

    if (!document.getElementById('hs-comparison-dot-display-fix')) {
      var style = document.createElement('style');
      style.id = 'hs-comparison-dot-display-fix';
      style.textContent = '.comparison-page .penetration-viz .peptide-dot{display:block!important;}.comparison-page .degradation-vis .deg-bar{display:block!important;height:100%;}.comparison-page .scorecard .sc-bar-fill{display:block!important;}';
      document.head.appendChild(style);
    }
  }

  restorePenetrationDots();

  var sticky = document.getElementById('stickyCta');
  var hero = document.querySelector('[data-comparison-page] .hero');
  if (!hero || !sticky) return;

  var ticking = false;
  function updateSticky() {
    var heroBottom = hero.getBoundingClientRect().bottom;
    sticky.classList.toggle('visible', heroBottom < 0);
    ticking = false;
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateSticky);
  }

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  requestUpdate();
})();
